import { useLocation } from "react-router";
import { useEffect, useState } from "react";
import { UserRole, getRoleFromPath, hasAccessToPath } from "@/utils/enum/user-role";

interface UseRoleAccessProps {
  userRole: UserRole | null;
}

interface UseRoleAccessReturn {
  hasAccess: boolean;
  requiredRole: UserRole | null;
  showAccessDenied: boolean;
  checkAccess: () => void;
}

export function useRoleAccess({ userRole }: UseRoleAccessProps): UseRoleAccessReturn {
  const location = useLocation();
  const pathname = location.pathname;
  const [showAccessDenied, setShowAccessDenied] = useState(false);
  const [hasAccess, setHasAccess] = useState(true);

  const requiredRole = getRoleFromPath(pathname);

  const checkAccess = () => {
    if (!userRole || !requiredRole) {
      setHasAccess(true);
      setShowAccessDenied(false);
      return;
    }

    const canAccess = hasAccessToPath(userRole, pathname);
    setHasAccess(canAccess);
    setShowAccessDenied(!canAccess);
  };

  useEffect(() => {
    checkAccess();
  }, [pathname, userRole]);

  return {
    hasAccess,
    requiredRole,
    showAccessDenied,
    checkAccess,
  };
}
